
import { uniqueId } from 'lodash'
import { Component, Prop, Vue } from 'vue-property-decorator'
import IconAction from '@/components/IconAction/IconAction.vue'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import CustomIcon from '@/components/CustomIcon/CustomIcon.vue'
import DatePicker from '@/components/DatePicker/DatePicker.vue'

@Component({
  components: {
    IconAction,
    SelectPicker,
    CustomIcon,
    DatePicker,
  },
})
export default class CellFormat extends Vue {
  @Prop({ required: true }) public value!: any

  @Prop({ required: true }) public field!: any

  @Prop({ required: false }) public item!: any

  @Prop({ required: true }) public dataTable!: any

  public refresh() {
    this.dataTable.refresh()
  }

  public triggerAction(event: string, item: any) {
    // @ts-ignore
    let action = this.fields
      .find((f: any) => f.key === 'action')
      .actions.find((a: any) => a.event === event)

    if (action && action.action !== undefined && action.action !== null) {
      let p = action.action(item, this.dataTable)

      if (p instanceof Promise) {
        p.then((refresh: boolean) => {
          if (refresh) {
            this.refresh()
          }
        })
      }
    }
    this.$emit(event, item)
  }

  public get local_value() {
    if (this.field.parse) {
      return this.field.parse(this.value)
    }
    return this.value
  }

  public set local_value(val: any) {
    this.$emit('update:value', val)
  }
}
